module.exports = "../../../../platform/assets/pageMainIcon/baobiaochaxunlei4.svg";